import { Upload } from "lucide-react";
import { useTranslation } from "react-i18next";

export function SchoolSetupField({
  controlId,
  label,
  value,
  onChange,
  type = "text",
}: {
  controlId: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: "text" | "number";
}) {
  return (
    <label className="block text-sm font-medium" htmlFor={controlId}>
      {label}
      <input
        className="mt-2 block min-h-11 w-full rounded-xl border border-input bg-background px-3 py-2 font-normal text-foreground shadow-xs focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30"
        data-control-id={controlId}
        id={controlId}
        min={type === "number" ? 0 : undefined}
        onChange={(event) => onChange(event.target.value)}
        type={type}
        value={value}
      />
    </label>
  );
}

export function SchoolSetupDocumentField({
  controlId,
  label,
  value,
  onChange,
}: {
  controlId: string;
  label: string;
  value: string | null;
  onChange: (value: string | null) => void;
}) {
  const { t } = useTranslation();
  return (
    <label
      className="block rounded-2xl border border-dashed border-border bg-muted/30 p-4 text-sm font-medium"
      htmlFor={controlId}
    >
      <span className="flex items-center gap-2">
        <Upload aria-hidden="true" className="size-4 text-primary" />
        {label}
      </span>
      <span className="mt-2 block text-sm font-normal text-muted-foreground">
        {value ?? t("school.documents.chooseFile")}
      </span>
      <input
        className="mt-3 block w-full text-sm font-normal file:mr-3 file:rounded-lg file:border-0 file:bg-background file:px-3 file:py-2 file:text-sm file:font-medium"
        data-control-id={controlId}
        id={controlId}
        onChange={(event) => onChange(event.target.files?.[0]?.name ?? null)}
        type="file"
      />
    </label>
  );
}
